import React from "react";
import style from "../stylees/Home.module.css";
import Header from "./Header";
import { Link } from "react-router-dom";
import { useAuth } from "../contextApi/Auth_context";
export default function Home() {
  const { logout } = useAuth();
  document.title = "Home";
  return (
    <>
      <div className={`${style.home}`}>
        <div className={`${style.main_layout} d-flex align-items-center `}>
          <main className="w-100">
            <div>
              <img
                className="img-fluid d-block mx-auto mb-3"
                src={require("../images/logo.png")}
                alt="Logo"
              />
            </div>
            <div className={`${style.main_layout_text}`}>
              <h1 className={`fw-bold text-center  m-0 text-muted `}>
                King Fahd Specialist Hospital
              </h1>
              <p className="fw-bold text-center fs-6 fs-md-4">
                Nuclear medicine department
              </p>
            </div>

            <div className={`${style.parts} container mt-5`}>
              <Link to={"/display"} className="text-decoration-none ">
                <div className="text-center p-3 col-12 col-sm-9 col md-7 col-lg-6 mx-auto shadow shadow-sm  fs-4 fw-bold rounded-3 my-3 ">
                  Show Patients
                </div>
              </Link>
              <Link to={"/add"} className="text-decoration-none">
                <div className="text-center p-3 col-12 col-sm-9 col md-7 col-lg-6 mx-auto shadow shadow-sm  fs-4 fw-bold rounded-3 my-3 ">
                  Add Patient
                </div>
              </Link>
              <Link to={"/controls"} className="text-decoration-none">
                <div className="text-center p-3 col-12 col-sm-9 col md-7 col-lg-6 mx-auto shadow shadow-sm  fs-4 fw-bold rounded-3 my-3 ">
                  Patients Management
                </div>
              </Link>
              <Link to={"/doctors"} className="text-decoration-none ">
                <div className="text-center p-3 col-12 col-sm-9 col md-7 col-lg-6 mx-auto shadow shadow-sm  fs-4 fw-bold rounded-3 my-3 ">
                  Doctors Management
                </div>
              </Link>
              {/* <button className="text-center p-3 col-12 col-sm-9 col md-7 col-lg-6 mx-auto shadow shadow-sm  fs-4 fw-bold rounded-3 my-3 " onClick={()=>logout()}>Logout</button> */}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
